import Immutable from 'immutable';
import { Markup, MarkupList, RawMarkup } from 'records/Markup';

export interface RawMarkupResponse {
  markups: RawMarkup[];
  cursor: string;
}

export interface MarkupResponseData {
  markups: MarkupList;
  cursor: string;
}

const defaultValues: MarkupResponseData = {
  markups: Immutable.List<Markup>(),
  cursor: '',
};

export const MarkupResponseFactory = Immutable.Record(
  defaultValues,
  'MarkupResponse'
);

export class MarkupResponse extends MarkupResponseFactory {
  static deserialize(rawMarkupResponse: RawMarkupResponse): MarkupResponse {
    return new MarkupResponse({
      markups: Immutable.List<Markup>(
        rawMarkupResponse.markups.map(Markup.deserialize)
      ),
      cursor: rawMarkupResponse.cursor,
    });
  }

  serialize(item: MarkupResponse): RawMarkupResponse {
    return item.toJS();
  }
}
